var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7, _path2, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHireTalentSkills = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  fill: "#E1F6E0",
  rx: 32
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 9.529,
  height: 24.882,
  x: 41.471,
  y: 24.794,
  fill: "#DDD",
  rx: 4
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 9.529,
  height: 29.647,
  x: 36.706,
  y: 20.029,
  fill: "#B9B9B9",
  rx: 4
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 26.471,
  height: 34.676,
  x: 15,
  y: 15,
  fill: "#FFE040",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F3A900",
  d: "M15 17.382A2.38 2.38 0 0 1 17.382 15h21.706a2.38 2.38 0 0 1 2.383 2.382z"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 11.647,
  height: 1.588,
  x: 24.265,
  y: 33.529,
  fill: "#656565",
  rx: 0.794
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 14.029,
  height: 1.588,
  x: 24.265,
  y: 38.559,
  fill: "#656565",
  rx: 0.794
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 9.794,
  height: 1.588,
  x: 24.265,
  y: 43.588,
  fill: "#656565",
  rx: 0.794
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00B55E",
  d: "M20.489 35.912h-.003a1 1 0 0 1-.804-.411l-.838-1.154a.72.72 0 0 1 .158-1.005.717.717 0 0 1 1.003.158l.485.669 1.421-1.935a.717.717 0 0 1 1.003-.153.72.72 0 0 1 .153 1.006l-1.775 2.418a1 1 0 0 1-.803.407M20.489 40.941h-.003a1 1 0 0 1-.804-.411l-.838-1.154a.72.72 0 0 1 .158-1.005.717.717 0 0 1 1.003.158l.485.67 1.421-1.936a.717.717 0 0 1 1.003-.152.72.72 0 0 1 .153 1.005l-1.775 2.418a1 1 0 0 1-.803.407M20.489 45.97h-.003a1 1 0 0 1-.804-.41l-.838-1.154a.72.72 0 0 1 .158-1.005.717.717 0 0 1 1.003.158l.485.669 1.421-1.935a.716.716 0 0 1 1.003-.153.72.72 0 0 1 .153 1.006l-1.775 2.417a1 1 0 0 1-.803.408"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 29.031,
  cy: 25.323,
  r: 5.294,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "hire-talent-skills_svg__a",
  width: 12,
  height: 11,
  x: 23,
  y: 20,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.032,
  cy: 25.323,
  r: 5.294,
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#hire-talent-skills_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29.019 30.36a.555.555 0 1 0-.177-1.097.555.555 0 0 0 .177 1.096"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7E4F4D",
  d: "m31.933 28.93-1.715-.79a.46.46 0 0 1-.266-.418v-1.155h-2.104v1.155a.46.46 0 0 1-.266.418l-1.716.79a1.38 1.38 0 0 0-.798 1.34l.152 2.532a.46.46 0 0 0 .458.431h6.446c.242 0 .444-.189.458-.431l.152-2.533a1.38 1.38 0 0 0-.8-1.339"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB3737",
  d: "m31.933 28.93-1.305-.6a1.776 1.776 0 0 1-1.733 1.41c-.85 0-1.563-.603-1.732-1.408l-1.302.598a1.38 1.38 0 0 0-.799 1.34l.153 2.532a.46.46 0 0 0 .457.431h6.447a.46.46 0 0 0 .457-.43l.152-2.534a1.37 1.37 0 0 0-.795-1.338"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#543736",
  d: "M27.848 27.77a2.52 2.52 0 0 0 2.106 0v-.612H27.85z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M30.16 22.033a1.27 1.27 0 0 0-1.155-1.37 1.265 1.265 0 0 0-1.364 1.16 1.27 1.27 0 0 0 1.156 1.37 1.265 1.265 0 0 0 1.363-1.16"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M28.898 26.312c1.395 0 2.525-1.088 2.525-2.43s-1.13-2.43-2.525-2.43c-1.394 0-2.525 1.088-2.525 2.43s1.13 2.43 2.525 2.43"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7E4F4D",
  d: "M31.299 24.63c-.017-.005-.122-.008-.122-.008a.42.42 0 0 1-.297-.122l-.183-.184a.42.42 0 0 0-.272-.122c-.41-.023-1.546-.126-2.447-.571a.21.21 0 0 0-.272.07 4.3 4.3 0 0 1-.692.818.42.42 0 0 1-.286.111h-.152a.3.3 0 0 0-.07.009c-.205.038-.343.236-.343.445v.153c0 .203.13.392.324.44q.066.015.128.01a.205.205 0 0 1 .216.173 2.106 2.106 0 0 0 2.067 1.732 2.106 2.106 0 0 0 2.068-1.732c.02-.103.11-.18.216-.172q.062.005.128-.011c.196-.048.324-.237.324-.44v-.192c.003-.2-.147-.345-.335-.406"
}))));
export default SvgHireTalentSkills;